import { render, staticRenderFns } from "./ForecastHistory.vue?vue&type=template&id=2a675eed&scoped=true"
import script from "./ForecastHistory.vue?vue&type=script&lang=js"
export * from "./ForecastHistory.vue?vue&type=script&lang=js"
import style0 from "./ForecastHistory.vue?vue&type=style&index=0&id=2a675eed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a675eed",
  null
  
)

export default component.exports